import React, { useState, useEffect, useCallback } from "react";
//import { Box, Typography, Grid, TableCell, TableRow } from "@mui/material";
//import Card from "../../components/Card";
//import { apiRequest } from "../../services/api-request";
// import { useAppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import downloadIcon from "../bank-css/icons/download-iocn.svg";
import profileIcon from "../bank-css/icons/farmer-pic1.jpg";
import logoIcon from "../bank-css/icons/logo.png";
import moment from "moment";

import { apiRequest } from "../../services/api-request";
import "./index.css";

let url = window.location.href;
let req_id = url.substring(url.lastIndexOf('/') + 1);

const ApplicationReport = () => {
  // const { user = {} } = useAppContext();
  const navigate = useNavigate();
  // const { userType } = useParams();
    const [showLoader, setShowLoader] = useState(true);
    const [fields, setFields] = useState({applicant_details:{}, animal_details:{}, veterinary_report_details:{}, vatObj:{}});

    // Gallery lightbox state
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    // Build flat array of all valid animal image URLs
    const allAnimalImages = (fields.animal_details?.images_keys || []).reduce((acc, key) => {
        const url = fields.animal_details?.images?.[key];
        if (url && url !== '') acc.push(url);
        return acc;
    }, []);

    const openLightbox = (index) => {
        setLightboxIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);

    const goToPrev = () => {
        setLightboxIndex((prev) => (prev === 0 ? allAnimalImages.length - 1 : prev - 1));
    };

    const goToNext = () => {
        setLightboxIndex((prev) => (prev === allAnimalImages.length - 1 ? 0 : prev + 1));
    };

    // Keyboard navigation
    const handleKeyDown = useCallback((e) => {
        if (!lightboxOpen) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') goToPrev();
        if (e.key === 'ArrowRight') goToNext();
    }, [lightboxOpen, allAnimalImages.length]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [handleKeyDown]);

    useEffect(() => {
        apiRequest({
          url: "bank/get-report-details?req_id="+req_id,
          method: "GET",
        })
        .then((res) => {
            setShowLoader(false)
            if(res.code === 0){
                alert(res.message)
                navigate('/application-report')
                return;
            }
            setFields(res.data);
        })
          .catch((err) => {
            console.log(err)
        });
    }, []);

    const getProxiedImage = (url) => {
        return url;
        // if (!url) return profileIcon; // fallback
        // return `${PROXY_BASE}${encodeURIComponent(url)}`;
    };

    const printInvoice = async () => {
      const element = document.getElementById("make_pdf");

      // Step 1: Render the full HTML to a canvas at high resolution
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        scrollY: 0,
        allowTaint: true,
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);

      // Step 2: Calculate dimensions to fit everything onto ONE page
      const pdfMargin = 10; // mm margin on each side

      const pageWidthMm = 210;   // A4 width in mm
      const pageContentWidth = pageWidthMm - pdfMargin * 2;

      // Convert canvas px → mm (96 DPI → mm: px / (96 * scale) * 25.4)
      const pxToMm = (px) => (px / (96 * 2)) * 25.4;

      const contentWidthMm = pxToMm(canvas.width);
      const contentHeightMm = pxToMm(canvas.height);

      // Scale height proportionally to fit the page width
      const scaleFactor = pageContentWidth / contentWidthMm;
      const scaledHeightMm = contentHeightMm * scaleFactor;

      // Create a custom-height PDF so everything fits on one page
      const pageHeightMm = scaledHeightMm + pdfMargin * 2;

      const pdf = new jsPDF({
        unit: "mm",
        format: [pageWidthMm, pageHeightMm],
        orientation: "p",
      });

      pdf.addImage(
        imgData,
        "JPEG",
        pdfMargin,          // x
        pdfMargin,          // y
        pageContentWidth,   // width
        scaledHeightMm      // height
      );

      pdf.save(`applicant-report-${req_id}.pdf`);
    };



    return (
        <div>
            <div className="loader-img" style={{ display: showLoader ? 'block' : 'none' }}></div>
            <div className="applicant-report-header">
                <h1 className="applicant-report-title">Applicant Report</h1>
                <div style={{display: 'flex'}}>
                    <button className="btn-download-report" onClick={printInvoice}>
                        <img src={downloadIcon} alt="Download" />
                        <span>Download Report</span>
                    </button>
                </div>
            </div>

            <div className="applicant-report-container" id="make_pdf">
                <div className="applicant-report-logo">
                    <div className="logo-icon">
                        <img src={logoIcon} alt="Anitra Logo" />
                    </div>
                    {/*<div className="logo-text">anitra</div>*/}
                </div>

                <div className="report-section">
                    <div className="report-section-header">APPLICANT DETAILS</div>
                    <div className="report-section-content">
                        <div className="applicant-info">
                            <div className="info-row">
                                <div className="info-label">Name:</div>
                                <div className="info-value">{fields.applicant_details?.name}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Contact Number:</div>
                                <div className="info-value">{fields.applicant_details?.mobile}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Address:</div>
                                <div className="info-value">{fields.applicant_details?.village_name}, {fields.applicant_details?.mandal_name}, {fields.applicant_details?.district_name}, {fields.applicant_details?.state_name}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Loan Proposal Number:</div>
                                <div className="info-value">{req_id}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Loan Officer Name:</div>
                                <div className="info-value">{fields.applicant_details?.loan_officer_name}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Circle:</div>
                                <div className="info-value">{fields.applicant_details?.circle}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Regional Office:</div>
                                <div className="info-value">{fields.applicant_details?.regional}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Branch Info:</div>
                                <div className="info-value">{fields.applicant_details?.branch_info}</div>
                            </div>
                            <div className="info-row">
                                <div className="info-label">Total Number of Animals:</div>
                                <div className="info-value">{fields.applicant_details?.no_of_milch_animal}</div>
                            </div>
                        </div>
                        <div className="applicant-image">
                            <img
                                src={
                                  fields.applicant_details?.pro_pic
                                    ? getProxiedImage(fields.applicant_details.pro_pic)
                                    : profileIcon
                                }
                                alt="Applicant Profile"
                              />
                        </div>
                    </div>
                </div>

                <div className="report-section">
                    <div className="report-section-header">ANIMAL DETAILS</div>
                    <div className="report-section-content animal-details-content">
                        <div className="animal-top-row">
                            <div className="animal-info">
                                <div className="info-row">
                                    <div className="info-label">Animal ID:</div>
                                    <div className="info-value">{fields.animal_details?.animal_id}</div>
                                </div>
                                <div className="info-row">
                                    <div className="info-label">Animal Name:</div>
                                    <div className="info-value">{fields.animal_details?.breed?.category_name}</div>
                                </div>
                                <div className="info-row">
                                    <div className="info-label">Tag Type:</div>
                                    <div className="info-value">{fields.animal_details?.tag_type}</div>
                                </div>
                                <div className="info-row">
                                    <div className="info-label">Tag Number:</div>
                                    <div className="info-value">{fields.animal_details?.tag_no}</div>
                                </div>
                                <div className="info-row">
                                    <div className="info-label">Animal Type:</div>
                                    <div className="info-value">{fields.animal_details?.type?.display_name}</div>
                                </div>
                                <div className="info-row">
                                    <div className="info-label">Breed:</div>
                                    <div className="info-value">{fields.animal_details?.breed?.name}</div>
                                </div>
                                <div className="info-row">
                                    <div className="info-label">Age:</div>
                                    <div className="info-value">{fields.animal_details?.details?.current_display_age}</div>
                                </div>
                                {
                                    fields.animal_details?.type?.display_name.includes("Already Calved") ?
                                    <div className="info-row">
                                        <div className="info-label">Milk:</div>
                                        <div className="info-value">{fields.animal_details?.details?.milking_quantity} ltr</div>
                                    </div>
                                    :
                                    <div className="info-row">
                                        <div className="info-label">Expected Milk:</div>
                                        <div className="info-value">{fields.animal_details?.details?.milking_quantity} ltr</div>
                                    </div>
                                }
                                {
                                    fields.animal_details?.type?.display_name.includes("Already Calved") ?
                                    <div className="info-row">
                                        <div className="info-label">Calvings:</div>
                                        <div className="info-value">{fields.animal_details?.details?.no_of_calvings}</div>
                                    </div>
                                    :
                                    <div className="info-row">
                                        <div className="info-label">Pregnancy:</div>
                                        {
                                            fields.animal_details?.details?.pregnancy_selector === 'No' ?
                                            <div className="info-value">{fields.animal_details?.details?.pregnancy_selector}</div>
                                            :
                                            <div className="info-value">{fields.animal_details?.details?.pregnancy_selector} - {fields.animal_details?.details?.pregnancy_period}</div>
                                        }
                                    </div>
                                }
                                {
                                    fields.animal_details?.type?.display_name.includes("Already Calved") ?
                                    <div className="info-row">
                                        <div className="info-label">Balance Milk Period:</div>
                                        <div className="info-value">{fields.animal_details?.details?.balance_milk_period}</div>
                                    </div>
                                    :
                                    null
                                }
                                {
                                    fields.animal_details?.details?.latitude && fields.animal_details?.details?.latitude !== '' ?
                                    <div className="info-row no-wrap">
                                        <div className="info-label">Geo location:</div>
                                        <div className="info-value">{fields.animal_details?.details?.latitude}, {fields.animal_details?.details?.longitude}</div>
                                    </div> : null
                                }
                                <div className="info-row no-wrap">
                                    <div className="info-label">Value of the Animal:</div>
                                    <div className="info-value">Rs. {fields?.vatObj?.animal_price}</div>
                                </div>
                            </div>
                            <div className="animal-info">
                                <div className="animal-images-top">
                                    <div className="animal-image">
                                    </div>
                                    <div className="animal-image animal-image-large">
                                        {
                                            fields.animal_details?.images_keys?.map((e, key) => {
                                                if(fields.animal_details?.images?.[e] !== '' && key === 0){
                                                    return <div className="animal-image animal-image-bottom gallery-thumb" key={key} onClick={() => openLightbox(0)}>
                                                        <img
                                                            src={getProxiedImage(fields.animal_details?.images?.[e])}
                                                            alt={`Animal ${key + 1}`}
                                                        />
                                                    </div>
                                                }
                                            })
                                        }
                                    </div>
                                </div>    
                            </div>
                        </div>
                        <div className="animal-images-bottom">
                            {
                                (() => {
                                    let validIndex = 0;
                                    return fields.animal_details?.images_keys?.map((e, key) => {
                                        if(fields.animal_details?.images?.[e] !== ''){
                                            const currentIndex = validIndex;
                                            validIndex++;
                                            if(key > 0){
                                                return <div className="animal-image animal-image-bottom gallery-thumb" key={key} onClick={() => openLightbox(currentIndex)}>
                                                    <img
                                                        src={getProxiedImage(fields.animal_details?.images?.[e])}
                                                        alt={`Animal ${key + 1}`}
                                                    />
                                                </div>
                                            }
                                        }
                                        return null;
                                    });
                                })()
                            }
                        </div>
                    </div>
                </div>

                {
                    fields?.vatObj?.is_for_veterinary === 'yes' ?
                    <div className="report-section veterinary-section">
                        <div className="report-section-header">VETERINARY DETAILS</div>

                        <div className="report-section-content veterinary-details">
                            <div className="info-row no-wrap">
                                <div className="info-label">Body Score:</div>
                                <div className="info-value">{fields.veterinary_report_details?.body_score || ''}</div>
                            </div>
                            <div>
                                <span>Field report, Breed Data and Visual records uploaded by the field officer is here by acknowledged.</span><br/>
                                <span>Basing on the above, after analysis this is to certify that the animal is {fields.veterinary_report_details?.animal_health || ''}.</span><br/>
                                <span>This certificate is digitally signed and for the Bank’s internal use only.</span>
                            </div>

                            <div className="vet-doctor">
                                <div className="vet-doc-1">
                                    <strong style={{color:'#59981A'}}>Veterinary Doctor Details</strong>
                                    <p><span className="vet-label">Name of Doctor:</span><span> {fields.veterinary_report_details?.doctor_info?.doctor_name}</span></p>
                                    <p><span className="vet-label">Registration Number:</span><span> {fields.veterinary_report_details?.doctor_info?.registration_number}</span></p>
                                    <p><span className="vet-label">Phone Number:</span><span> {fields.veterinary_report_details?.doctor_info?.doctor_phone}</span></p>
                                    <p><span className="vet-label">Designation:</span><span> {fields.veterinary_report_details?.doctor_info?.designation}</span></p>
                                </div>
                                <div className="vet-signature">
                                    <div className="signature-title">SIGNATURE</div>
                                    <div className="signature-label">Signature of Doctor</div>
                                    <div>
                                        <img
                                            src={getProxiedImage(fields.veterinary_report_details?.doctor_info?.signature)}
                                            width="110px"
                                            alt="Signature"
                                        />
                                    </div>
                                    <div className="signature-name">
                                        <span className="vet-label">Date :</span>
                                        <span>{moment(fields.veterinary_report_details?.doctor_info?.date).format('DD/MM/YYYY')}</span>
                                    </div>
                                    <div className="signature-name">
                                        <span className="vet-label">Name :</span>
                                        <span>{fields.veterinary_report_details?.doctor_info?.doctor_name}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div> : 
                    <div className="report-section veterinary-section">
                        <div className="report-section-header">VETERINARY CERTIFICATE</div>
                        <div className="report-section-content veterinary-details a4-content">
                            <img
                                src={getProxiedImage(fields?.vatObj?.document)}
                                alt={`Veterinary Doc`}
                                className="a4-image"
                            />
                        </div>
                    </div>    
                }

            </div>

            {/* Gallery Lightbox */}
            {lightboxOpen && allAnimalImages.length > 0 && (
                <div className="gallery-lightbox-overlay" onClick={closeLightbox}>
                    <div className="gallery-lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button className="gallery-lightbox-close" onClick={closeLightbox} title="Close">&times;</button>

                        {allAnimalImages.length > 1 && (
                            <button className="gallery-lightbox-arrow gallery-arrow-left" onClick={goToPrev} title="Previous">
                                &#10094;
                            </button>
                        )}

                        <img
                            src={getProxiedImage(allAnimalImages[lightboxIndex])}
                            alt={`Animal ${lightboxIndex + 1}`}
                            className="gallery-lightbox-image"
                        />

                        {allAnimalImages.length > 1 && (
                            <button className="gallery-lightbox-arrow gallery-arrow-right" onClick={goToNext} title="Next">
                                &#10095;
                            </button>
                        )}

                        <div className="gallery-lightbox-counter">
                            {lightboxIndex + 1} / {allAnimalImages.length}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ApplicationReport;